import { render, staticRenderFns } from "./ProductContentSubjectTabs.vue?vue&type=template&id=c4cd9df0&scoped=true"
import script from "./ProductContentSubjectTabs.vue?vue&type=script&lang=js"
export * from "./ProductContentSubjectTabs.vue?vue&type=script&lang=js"
import style0 from "./ProductContentSubjectTabs.vue?vue&type=style&index=0&id=c4cd9df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cd9df0",
  null
  
)

export default component.exports